// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloudDownloadFilledSvg from "@fishx/icons-svg/es/asn/CloudDownloadFilled";
import FishxIcon from '../components/FishxIcon';

var CloudDownloadFilled = function CloudDownloadFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloudDownloadFilledSvg
  }));
};

CloudDownloadFilled.displayName = 'CloudDownloadFilled';
export default React.forwardRef(CloudDownloadFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CloudDownloadFilled.js
// module id = 2241
// module chunks = 0